import React, { SVGProps } from 'react'
const SvgShow = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path d="M3.58 13.475c5.7-6.967 11.14-6.967 16.84 0a.75.75 0 1 0 1.16-.95c-6.3-7.7-12.86-7.7-19.16 0a.75.75 0 1 0 1.16.95Z" />
      <path d="M3.58 12.525c5.7 6.967 11.14 6.967 16.84 0a.75.75 0 1 1 1.16.95c-6.3 7.7-12.86 7.7-19.16 0a.75.75 0 1 1 1.16-.95Z" />
      <path d="M12 16.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm0-1.5a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Z" />
    </g>
  </svg>
)
export default SvgShow
